exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-77145e98] {\n  min-height: 17.5rem;\n}", ""]);

// exports
